import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

import { create } from "@/lib/store";
import { hashStorage } from "@/shared/utils/hashStorage";

const STORE_NAME = "GrowthCentre";

interface GrowthCentreState {
  selectedExperiment: string | null;
  maiteWidget: {
    question: string;
    isModalOpen: boolean;
  };
}

interface GrowthCentreActions {
  setSelectedExperiment: (experimentId: string | null) => void;
  setMaiteQuestion: (question: string) => void;
  setMaiteModalOpen: (isOpen: boolean) => void;
  resetMaiteWidget: () => void;
}

type GrowthCentreStore = GrowthCentreState & GrowthCentreActions;

const defaultState: GrowthCentreState = {
  selectedExperiment: null,
  maiteWidget: {
    question: "",
    isModalOpen: false,
  },
};

export const useGrowthCentreStore = create<GrowthCentreStore>()(
  devtools(
    persist(
      immer((set) => ({
        ...defaultState,
        setSelectedExperiment: (experimentId) =>
          set((state) => {
            state.selectedExperiment = experimentId;
          }),
        setMaiteQuestion: (question) =>
          set((state) => {
            state.maiteWidget.question = question;
          }),
        setMaiteModalOpen: (isOpen) =>
          set((state) => {
            state.maiteWidget.isModalOpen = isOpen;
          }),
        resetMaiteWidget: () =>
          set((state) => {
            state.maiteWidget = defaultState.maiteWidget;
          }),
      })),
      {
        name: STORE_NAME,
        storage: createJSONStorage(() => hashStorage),
      }
    ),
    { name: STORE_NAME }
  )
);
